module.exports = __webpack_public_path__ + "static/media/my_wardrobe-click@shortened.2f5371ad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/my_wardrobe-click@shortened.gif
// module id = 117
// module chunks = 0